<template>
  <div id="app">
    <transition name="slide-fade"
      mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  // import { mapActions } from 'vuex';

  export default {
    name: 'app',
    data() {
      return {
        resourceUsuario: this.$api.usuario(this.$resource),
        resourceCliente: this.$api.cliente(this.$resource),
      }
    },
    beforeCreate() {
    },
    methods: {
      /* ...mapActions('roles', [
        'setToken',
      ]),*/
      logInAuth() {
        const usuario = {
          email: "stshop@compart.com.mx",
          password: "Compart33461"
        };
        this.resourceUsuario.logIn(usuario)
          .then((response) => {
            localStorage.setItem('token', response.body.access_token);
          })
          .catch((err) => {
            this.$error(this, err);
          });

      },
      validateStShop() {
        this.resourceCliente.validacion()
          .then((response) => {
            if(response.data.valido === false) {
              this.$router.push({ name: 'licencia'});
            } 
          })
          .catch((err) => {
            this.$error(this, err);
          });

      },
      getParametros() {
        this.resourceCliente.parametros()
          .then((response) => {
            const parametros = {};
            response.body.data.forEach((el) => {
              switch (el.descripcion.trim()) {
                case 'almacen':
                  parametros.almacen = el.parametro.trim();
                  break;
                case 'pago':
                  parametros.pago = el.parametro.trim();
                  break; 
                case 'envio':
                  parametros.envio = el.parametro.trim();
                  break;
                case 'ruta_imagen':
                  parametros.ruta_imagen = el.parametro.trim();
                  break;
                case 'existencia_negativa':
                  parametros.existencia_negativa = el.parametro.trim();
                  break;
                case 'sitio':
                  parametros.sitio = el.parametro.trim();
                  break;
                case 'subdepto_descr':
                  parametros.subdepto_descr = el.parametro.trim();
                  break;
                case 'categoria':
                  parametros.categoria = el.parametro.trim();
                  break; 
                case 'categoria_descr':
                  parametros.categoria_descr = el.parametro.trim();
                  break;
                case 'tipoproducto':
                  parametros.tipoproducto = el.parametro.trim();
                  break;
                case 'tipoproducto_descr':
                  parametros.tipoproducto_descr = el.parametro.trim();
                  break;
                case 'ano':
                  parametros.ano = el.parametro.trim();
                  break;
                case 'ano_descr':
                  parametros.ano_descr = el.parametro.trim();
                  break;
                case 'departamento':
                  parametros.departamento = el.parametro.trim();
                  break; 
                case 'departamento_descr':
                  parametros.departamento_descr = el.parametro.trim();
                  break;
                case 'subdepto':
                  parametros.subdepto = el.parametro.trim();
                  break;
                case 'envio_por_cobrar':
                  parametros.envio_por_cobrar = el.parametro.trim();
                  break; 
                case 'metodo_envio':
                  parametros.metodo_envio = el.parametro.trim();
                  break;
                case 'porcentaje_envio':
                  parametros.porcentaje_envio = el.parametro.trim();
                  break; 
                case 'articulo_envio':
                  parametros.articulo_envio = el.parametro.trim();
                  break; 
                case 'ocultar_precios':
                  parametros.ocultar_precios = el.parametro.trim();
                  break; 
                case 'pagos_meses':
                  parametros.pagos_meses = el.parametro.trim();
                  break;                
              }
            })
            localStorage.setItem('parametros', JSON.stringify(parametros));
            this.parametros = parametros;
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
    },
    mounted() {
      this.logInAuth();
      this.getParametros();
      // this.validateStShop();
    },
  };
</script>

<style>
  @import './assets/css/main.css';

  #app {
    background-color: #fff  ;
    padding-bottom: 1em;
    min-height: 100vh;
    height: 100%;
  }

  .slide-fade-enter-active {
    transition: all .1s ease;
  }
  .slide-fade-leave-active {
    transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-active {
    transform: translateX(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue